import { render, staticRenderFns } from "./BtcTransactions.vue?vue&type=template&id=b9dfa600"
import script from "./BtcTransactions.vue?vue&type=script&lang=js"
export * from "./BtcTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports